import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';
import { CallIcon } from './CallUI';

const REPORT_REASONS = [
  "עירום או תוכן מיני",
  "שפה פוגענית או מעליבה",
  "הטרדה או בריונות",
  "אלימות או התנהגות מאיימת",
  "סמים או חומרים לא חוקיים",
  "דברי שנאה או אפליה",
  "פרופיל מזויף או התחזות",
  "ספאם או פניות מסחריות לא רצויות",
  "אחר",
];

const ReportModal = ({ partnerId, partnerUsername, token, onClose }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const dialogRef = useRef(null);
  const dismissRef = useRef(onClose);
  dismissRef.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    dialogRef.current?.focus();
    const onKey = event => {
      if (event.key === 'Escape') dismissRef.current();
      if (event.key !== 'Tab') return;
      const nodes = [...dialogRef.current.querySelectorAll('button:not(:disabled), input:not(:disabled)')];
      const first = nodes[0], last = nodes[nodes.length - 1];
      if (!nodes.length) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialogRef.current)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialogRef.current)) {
        event.preventDefault(); first.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('keydown', onKey); if (previous?.isConnected) previous.focus(); };
  }, []);

  const handleSubmit = async () => {
    if (!reason) {
      setError("יש לבחור סיבה");
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await axios.post(
        `${API_BASE_URL}/report_user`,
        { blocked_id: partnerId, reason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || "שליחת הדיווח נכשלה");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="safety-overlay">
      <div ref={dialogRef} className="safety-dialog" role="dialog" aria-modal="true" aria-labelledby="safety-title" tabIndex={-1}>
        <button className="safety-close" onClick={onClose} aria-label="סגירת הדיווח"><CallIcon name="close" /></button>
        <CallIcon name={done ? 'check' : 'shield'} />
        <h2 id="safety-title">{done ? "השליטה בידיים שלכם." : "הנוחות שלכם קודמת לכול."}</h2>
        {done ? <>
          <p>הדיווח שלכם על <strong>{partnerUsername}</strong> נשלח והחשבון נחסם. אפשר לנהל חשבונות חסומים בפרופיל שלכם.</p>
          <div className="safety-actions"><button onClick={onClose}>סיום</button></div>
        </> : <>
          <p>דיווח <strong>{partnerUsername}</strong>. הפעולה מסיימת את השיחה וחוסמת התאמות עתידיות עם החשבון הזה.</p>
          <fieldset className="safety-reasons" disabled={submitting}>
            <legend>מה קרה?</legend>
            {REPORT_REASONS.map(item => <label key={item}>
              <input type="radio" name="reason" value={item} checked={reason === item} onChange={e => setReason(e.target.value)} />
              <span>{item}</span>
            </label>)}
          </fieldset>
          {error && <div role="alert" className="safety-error">{error}</div>}
          <div className="safety-actions">
            <button onClick={onClose}>ביטול</button>
            <button className="safety-submit" onClick={handleSubmit} disabled={submitting}>{submitting ? 'שולחים…' : "דיווח וחסימה"}</button>
          </div>
        </>}
      </div>
    </div>
  );
};

export default ReportModal;
